import styled from 'styled-components';

export const Header = styled.header`
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 20px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    height: 64px;
    padding: 0 10px;
    gap: 8px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  min-width: 0;

  @media (max-width: 768px) {
    gap: 6px;
    flex: 1;
  }
`;

export const MenuToggle = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  color: #64748b;
  transition: all 0.2s ease;
  min-width: 42px;
  min-height: 42px;

  @media (max-width: 768px) {
    display: none;
  }

  &:hover {
    background: #f1f5f9;
    color: #334155;
  }
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;

  @media (max-width: 768px) {
    max-width: 46vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NotificationButton = styled.button`
  position: relative;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  color: #64748b;
  transition: all 0.2s ease;

  &:hover {
    background: #f1f5f9;
    color: #334155;
  }
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  background: #ef4444;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  gap: 8px;
  min-width: 300px;

  @media (max-width: 768px) {
    min-width: 200px;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

export const SearchInput = styled.input`
  border: none;
  background: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  color: #334155;

  &::placeholder {
    color: #94a3b8;
  }
`;

export const SearchButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #64748b;
  padding: 4px;
`;

export const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  @media (max-width: 768px) {
    gap: 2px;
  }
`;

export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8fafc;
  }

  @media (max-width: 768px) {
    padding: 4px;
  }
`;

export const ProfileAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: #30D5C8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: white;

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }
`;

export const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ProfileName = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
`;

export const ProfileEmail = styled.span`
  font-size: 12px;
  color: #64748b;
`;

export const ProfileMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #64748b;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  min-width: 40px;
  min-height: 40px;

  &:hover {
    background: #f1f5f9;
    color: #334155;
  }
`;

export const ProfileDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 1000;
  margin-top: 8px;

  @media (max-width: 480px) {
    position: fixed;
    top: 58px;
    right: 10px;
    width: min(240px, calc(100vw - 20px));
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
  color: #334155;

  &:hover {
    background: #f8fafc;
  }
`;

export const DropdownIcon = styled.span`
  font-size: 16px;
  width: 20px;
  text-align: center;
`;

export const DropdownDivider = styled.div`
  height: 1px;
  background: #e2e8f0;
  margin: 8px 0;
`;

export const NotificationsDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  width: 350px;
  z-index: 1000;
  margin-top: 8px;

  @media (max-width: 768px) {
    width: 300px;
  }

  @media (max-width: 480px) {
    width: 280px;
  }
`;

export const NotificationHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NotificationTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const MarkAllReadButton = styled.button`
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
`;

export const NotificationList = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;

export const NotificationItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8fafc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const NotificationIcon = styled.span`
  font-size: 20px;
  width: 24px;
  text-align: center;
  margin-top: 2px;
`;

export const NotificationContent = styled.div`
  flex: 1;
`;

export const NotificationItemTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
  margin-bottom: 4px;
`;

export const NotificationText = styled.div`
  font-size: 13px;
  color: #64748b;
  margin-bottom: 4px;
`;

export const NotificationTime = styled.div`
  font-size: 12px;
  color: #94a3b8;
`;
